import { render, staticRenderFns } from "./TechnicalMessageList.vue?vue&type=template&id=38951658&"
import script from "./TechnicalMessageList.vue?vue&type=script&lang=ts&"
export * from "./TechnicalMessageList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports